<template>
    <div v-if="showCorridorHelp" id="afdc-corridor-help-container" tabindex="0" v-on-clickaway="closePopup">
      <button id="afdc-close-corridor-help" class="afdc-float-right" v-on:click="closePopup">
        <span class="afdc-sr-only">{{ $t('Close') }}</span>
        <font-awesome-icon icon="times-circle" class="afdc-fa-icon"/>
      </button>
      <div id="afdc-top-grid" class="afdc-flex-grid">
        <div class="afdc-flex-col">{{ $t('Criteria for Corridors') }}</div>
      </div>
      <div class ="afdc-flex-grid">
        <div class="afdc-flex-col afdc-title-col">
          <img alt="electricity" src="../assets/images/box_electricity_grey.png">
        </div>
        <div class="afdc-flex-col afdc-title-col">
          <img alt="compressed natural gas" src="../assets/images/box_cng_grey.png">
        </div>
        <div class="afdc-flex-col afdc-title-col">
          <img alt="liquefied natural gas" src="../assets/images/box_lng_grey.png">
        </div>
        <div class="afdc-flex-col afdc-title-col">
          <img alt="hydrogen" src="../assets/images/box_hydrogen_grey.png">
        </div>
        <div class="afdc-flex-col afdc-title-col">
          <img alt="propane" src="../assets/images/box_propane_grey.png">
        </div>
      </div>
      <div class ="afdc-flex-grid">
        <div class="afdc-flex-col">{{ $t('Only public stations') }}</div>
      </div>
      <div class ="afdc-flex-grid">
        <div class="afdc-flex-col">{{ $t('5 miles from the highway') }}</div>
      </div>
      <div class ="afdc-flex-grid">
        <div class="afdc-flex-col">{{ $t('50 miles between stations') }}</div>
        <div class="afdc-flex-col">{{ $t('150 miles between stations') }}</div>
        <div class="afdc-flex-col">{{ $t('200 miles between stations') }}</div>
        <div class="afdc-flex-col">{{ $t('100 miles between stations') }}</div>
        <div class="afdc-flex-col">{{ $t('150 miles between stations') }}</div>
      </div>
      <div class ="afdc-flex-grid">
        <div class="afdc-flex-col">{{ $t('Only DC fast charging stations with CHAdeMO and CCS connectors (no Tesla)') }}</div>
        <div class="afdc-flex-col">{{ $t('Only fast-fill stations with 3,600 psi fill pressure') }}</div>
        <div class="afdc-flex-col afdc-flex-col-white"></div>
        <div class="afdc-flex-col">{{ $t('Only retail stations (accept payment at the point of sale)') }}</div>
        <div class="afdc-flex-col">{{ $t('Only primary stations (offer fueling capabilities for vehicles)') }}</div>
      </div>
    </div>
</template>

<script>

import { mixin as clickaway } from 'vue-clickaway';

export default {
  name: 'CorridorHelp',

  mixins: [
    clickaway,
  ],

  computed: {
    showCorridorHelp() {
      return this.$store.getters.getCorridorPopup;
    },
  },

  watch: {
    '$store.getters.getNavActiveTab': {
      immediate: true,
      handler: 'checkClose',
    },
  },

  methods: {
    afterEnter() {
      this.focusOnLoad();
    },

    focusOnLoad() {
      if (this.$el) {
        this.$el.focus();
      }
    },

    checkClose() {
      const newTab = this.$store.getters.getNavActiveTab;
      if (newTab !== 'corridors') {
        this.closePopup();
      }
    },

    closePopup() {
      this.$store.commit('setCorridorPopup', false);
    },
  },
};
</script>

<style lang="scss">
  #corridor-help-container {
    position: absolute;
    background: white;
    right: 0;
    z-index: 15;
    width: 95%;
    max-width: 625px;
    height: auto;
    overflow: auto;
    padding: 20px;
    border: 1px solid #ccc;
    box-shadow: 5px 0px 10px 0px #a3a3a3;

    #close-corridor-help {
      font-size: 32px;
      margin: -15px -5px -5px 0;
    }

    .fa-icon {
      color: #999;
      &:hover {
        color: #666;
        cursor: pointer;
      }
    }

    .direction-icon {
      font-size: 25px;
      color: #666;
    }

    .corridor-chart-img {
      width: 100%;
    }

    .flex-grid {
      display: flex;
    }

    .flex-col {
      flex: 1;
      margin: 5px;
      background-color: #ccc;
      justify-content: center;
      display: flex;
      padding: 9px 5px 9px 9px;
      line-height: 18px;
      font-size: 14px;
    }

    .flex-col-white {
      background-color: #fff;
    }

    #top-grid {
      margin-top: 40px;
      .flex-col {
        background-color: #1F82BB;
        color: #fff;
        font-size: 25px;
        padding: 15px;
      }
    }

    .title-col {
      display: flex;
      align-items: center;
      padding: 0 0;
    }

    .fuel-icon-img {
      width: 25%;
      img {
        width: 100%;
      }
    }

    .fuel-dmd-img {
      width: 30%;
      img {
        width: 100%;
      }
    }

    .fuel-title-txt {
      p {
        line-height: 14px;
        margin-bottom: 0;
      }
    }
  }

</style>
